import type { KeyboardEvent } from 'react';

import { useChat } from '@/features/ai-chat/state/useChat';

export function useMessageInput() {
  const {
    inputMessage,
    setInputMessage,
    handleSend,
    isInitializing,
    isSending,
    conversationId,
    animatedText
  } = useChat();

  const isDisabled = !conversationId || isSending || isInitializing || !!animatedText;

  const handleChange = (value: string) => {
    setInputMessage(value);
  };

  const handleKeyDown = (e: KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      if (!isDisabled && inputMessage.trim()) {
        handleSend();
      }
    }
  };

  return { inputMessage, isDisabled, handleSend, handleChange, handleKeyDown } as const;
}
